import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import Typography from './Typography';
import Button from './Button';

const shouldForwardProp = prop => !['isClosing', 'isVisible'].includes(prop);

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const slideDown = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
`;

const DialogContainer = styled.div.withConfig({ shouldForwardProp })`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  border-radius: 20px 20px 0 0;
  padding: 24px;
  animation: ${props => (props.isClosing ? slideDown : slideUp)} 0.3s ease-out;
  z-index: 1002;
`;

const Title = styled.div`
  margin-bottom: 30px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SlideDialogV = ({
  isOpen,
  onClose,
  title,
  description,
  buttons = [],
  buttonStyle,
  innertComponent,
  style,
}) => {
  const [visible, setVisible] = useState(isOpen);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      setIsClosing(false);
    } else if (visible) {
      setIsClosing(true);
      const timer = setTimeout(() => {
        setVisible(false);
      }, 200); // 애니메이션 지속 시간과 일치해야 함
      return () => clearTimeout(timer);
    }
  }, [isOpen, visible]);

  if (!visible) return null;

  return (
    <>
      <Overlay onClick={onClose} />
      <DialogContainer isClosing={isClosing} style={style}>
        <Title>
          <Typography variant="subtitleBold">{title}</Typography>
          {description && (
            <Typography variant="body1Medium" style={{ whiteSpace: 'pre-wrap' }}>
              {description}
            </Typography>
          )}
        </Title>
        {innertComponent && innertComponent}
        <ButtonContainer style={buttonStyle}>
          {buttons.map((button, index) => (
            <Button
              style={button.style}
              key={index}
              onClick={button.onClick}
              color={button.color}
              value={button.label}
              disabled={button.disabled || false}
            />
          ))}
        </ButtonContainer>
      </DialogContainer>
    </>
  );
};

export default SlideDialogV;
